import { memo } from "react";

import { Blueprint } from "types/generated";
import { SortStateDescriptor } from "components/Filters/types";
import TableSimple from "ds/components/TableSimple";

import useTemplatesTableStore from "./useTemplateVersionsTableStore";
import { FILTERS_ORDER_SETTINGS_KEY } from "../constants";
import { TEMPLATE_VERSIONS_TABLE_CELLS } from "./Cells";
import { TEMPLATE_VERSIONS_SORT_CONFIG } from "./constants";

type TemplatesTableProps = {
  templates: Blueprint[];
  loading?: boolean;
  rowsPerPage: number;
  sortCallback: (sortDescriptor: SortStateDescriptor) => void;
};

const TemplatesTable = ({ templates, loading, rowsPerPage, sortCallback }: TemplatesTableProps) => {
  return (
    <TableSimple
      data={templates}
      loading={loading}
      store={useTemplatesTableStore}
      ariaLabel="Templates table"
      rowsPerPage={rowsPerPage}
      sortCallback={sortCallback}
      filtersStorageKey={FILTERS_ORDER_SETTINGS_KEY}
      cellPerColumn={TEMPLATE_VERSIONS_TABLE_CELLS}
      sortConfig={TEMPLATE_VERSIONS_SORT_CONFIG}
    />
  );
};

export default memo(TemplatesTable);
